import styled from 'styled-components';
import Tabs from '../../../../../chat/components/Tabs';

const StyledTabComponent = styled(Tabs)`
  margin-top: 10px;
  width: 60%;

  &.MuiTabs-root {
    min-height: unset;
  }

  .MuiButtonBase-root {
    min-width: unset;
    min-height: unset;
    font-size: 12px;
    padding: 3px;
  }
`;

export { StyledTabComponent };
